import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { FaChevronUp, FaFilePdf } from "react-icons/fa";
import Loader from '../../../../../components/Loader/Loader';
import { postWhatOccurredStore } from '../../../../../apiservices/ApiServices';
import { Row, Col } from 'react-bootstrap';
import UploadWithSignature from '../../../../../components/UploadWithSignature/UploadWithSignature';
import SelectFild from '../../../../../components/SelectFild/SelectFild';

const BuildingInfrastructureRelated = ({ details, selectedCheckboxes, postUpdateData, toast }) => {
    const [isLoadings, setLoadings] = useState(false);
    const [preImg, setPreImg] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);

    const initialValues = {
        id: '',
        severityDamage: '',
        wasAreaSecured: '',
        wasMaintenanceNotified: '',
        wasAreaCordonedOff: '',
        recentMaintenanceorRepairs: '',
        anyHazardofCollapse: '',
        wasImmediateCleanupDone: '',
        effectedPassengerFlow: '',
        natureOfCrowd: '',
        description: '',
    };

    useEffect(() => {
        if (details?.what_occurred?.details?.["8"]?.[0]) {
            const detailItem = details.what_occurred.details["8"][0];
            const parsedData = JSON.parse(detailItem.data_json)?.[0] || {};

            setPreImg(detailItem.image_json);

            formik.setValues({
                id: detailItem.id || '',
                severityDamage: parsedData.severityDamage || '',
                wasAreaSecured: parsedData.wasAreaSecured || '',
                wasMaintenanceNotified: parsedData.wasMaintenanceNotified || '',
                wasAreaCordonedOff: parsedData.wasAreaCordonedOff || '',
                recentMaintenanceorRepairs: parsedData.recentMaintenanceorRepairs || '',
                anyHazardofCollapse: parsedData.anyHazardofCollapse || '',
                wasImmediateCleanupDone: parsedData.wasImmediateCleanupDone || '',
                effectedPassengerFlow: parsedData.effectedPassengerFlow || '',
                natureOfCrowd: parsedData.natureOfCrowd || '',
                description: parsedData.description || '',
            });
        }
    }, [details]);

    const formik = useFormik({
        initialValues,
        enableReinitialize: true,
        validationSchema: "",
        onSubmit: async (values) => {
            const selectedCatList = JSON.stringify(selectedCheckboxes);
            let param = {
                severityDamage: values.severityDamage,
                wasAreaSecured: values.wasAreaSecured,
                wasMaintenanceNotified: values.wasMaintenanceNotified,
                wasAreaCordonedOff: values.wasAreaCordonedOff,
                recentMaintenanceorRepairs: values.recentMaintenanceorRepairs,
                anyHazardofCollapse: values.anyHazardofCollapse,
                wasImmediateCleanupDone: values.wasImmediateCleanupDone,
                effectedPassengerFlow: values.effectedPassengerFlow,
                natureOfCrowd: values.natureOfCrowd,
                description: values.description,
            };

            const formData = new FormData();
            formData.append('category_data', selectedCatList);

            formData.append('what_occurred_detail_id', details?.what_occurred?.details?.["8"]?.[0]?.id || '');
            formData.append('incident_header_id', details.header_id);
            const main_category = 8;
            const sub_category = selectedCheckboxes["8"];
            formData.append('category_id', main_category);

            formData.append('what_occurred_header_id', details?.what_occurred?.id);
            formData.append('sub_category_id', JSON.stringify(sub_category));

            const data_json = [];
            data_json.push(param);
            formData.append('data_json', JSON.stringify(data_json));

            uploadedFiles.forEach(file => {
                console.log('file.signatureData', file)

                if (file.originalFile.type === 'application/pdf') {
                    formData.append('images[]', file.originalFile);
                }

                if (file.signatureData) {
                    const blob = dataURLtoBlob(file.signatureData);
                    formData.append('images[]', blob, `signature_${file.originalFile.name}`);
                }
            });

            setLoadings(true);
            try {
                const res = await postWhatOccurredStore(formData);
                console.log("res", res.data);
                toast.success(res.data.message);
                postUpdateData();
            } catch (error) {
                toast.error(error?.response?.data?.message || 'Something went wrong');
            } finally {
                setLoadings(false);
            }

        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched, } = formik;

    const dataURLtoBlob = (dataURL) => {
        const arr = dataURL.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new Blob([u8arr], { type: mime });
    };

    return (
        <>
            <div className="form-box">
                <form onSubmit={handleSubmit} autoComplete="off">
                    <div className="GroupList fieldset">
                        <div className='toggle-button'>
                            <h2 className="listTitle">Building / Facility / Infrastructure Related</h2>
                            <div className="btnColaps">
                                <FaChevronUp />
                            </div>
                        </div>

                        <div className="subFilds">
                            <Row>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Severity Damage</label>
                                        <SelectFild
                                            Firstop='Select'
                                            selectName="severityDamage"
                                            options={[
                                                { name: 'Minor', id: 'minor' },
                                                { name: 'Major', id: 'major' },
                                                { name: 'Critical', id: 'critical' },
                                            ]}
                                            value={values.severityDamage}
                                            onChange={(selectedOption) => setFieldValue("severityDamage", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.severityDamage && touched.severityDamage && (
                                            <p className="errormsg">{errors.severityDamage}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Was Area Secured?</label>
                                        <SelectFild
                                            Firstop='Select'
                                            selectName="wasAreaSecured"
                                            options={[
                                                { name: 'No', id: 'no' },
                                                { name: 'Yes', id: 'yes' },
                                            ]}
                                            value={values.wasAreaSecured}
                                            onChange={(selectedOption) => setFieldValue("wasAreaSecured", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.wasAreaSecured && touched.wasAreaSecured && (
                                            <p className="errormsg">{errors.wasAreaSecured}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Was Maintenance Notified?</label>
                                        <SelectFild
                                            Firstop='Select'
                                            selectName="wasMaintenanceNotified"
                                            options={[
                                                { name: 'No', id: 'no' },
                                                { name: 'Yes', id: 'yes' },
                                            ]}
                                            value={values.wasMaintenanceNotified}
                                            onChange={(selectedOption) => setFieldValue("wasMaintenanceNotified", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.wasMaintenanceNotified && touched.wasMaintenanceNotified && (
                                            <p className="errormsg">{errors.wasMaintenanceNotified}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Was Area Cordoned off?</label>
                                        <SelectFild
                                            Firstop='Select'
                                            selectName="wasAreaCordonedOff"
                                            options={[
                                                { name: 'No', id: 'no' },
                                                { name: 'Yes', id: 'yes' },
                                            ]}
                                            value={values.wasAreaCordonedOff}
                                            onChange={(selectedOption) => setFieldValue("wasAreaCordonedOff", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.wasAreaCordonedOff && touched.wasAreaCordonedOff && (
                                            <p className="errormsg">{errors.wasAreaCordonedOff}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Recent Maintenance or Repairs</label>
                                        <SelectFild
                                            Firstop='Select'
                                            selectName="recentMaintenanceorRepairs"
                                            options={[
                                                { name: 'No', id: 'no' },
                                                { name: 'Yes', id: 'yes' },
                                            ]}
                                            value={values.recentMaintenanceorRepairs}
                                            onChange={(selectedOption) => setFieldValue("recentMaintenanceorRepairs", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.recentMaintenanceorRepairs && touched.recentMaintenanceorRepairs && (
                                            <p className="errormsg">{errors.recentMaintenanceorRepairs}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Any Hazard of Collapse?</label>
                                        <SelectFild
                                            Firstop='Select'
                                            selectName="anyHazardofCollapse"
                                            options={[
                                                { name: 'No', id: 'no' },
                                                { name: 'Yes', id: 'yes' },
                                            ]}
                                            value={values.anyHazardofCollapse}
                                            onChange={(selectedOption) => setFieldValue("anyHazardofCollapse", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.anyHazardofCollapse && touched.anyHazardofCollapse && (
                                            <p className="errormsg">{errors.anyHazardofCollapse}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Was Immediate Cleanup Done?</label>
                                        <SelectFild
                                            Firstop='Select'
                                            selectName="wasImmediateCleanupDone"
                                            options={[
                                                { name: 'No', id: 'no' },
                                                { name: 'Yes', id: 'yes' },
                                            ]}
                                            value={values.wasImmediateCleanupDone}
                                            onChange={(selectedOption) => setFieldValue("wasImmediateCleanupDone", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.wasImmediateCleanupDone && touched.wasImmediateCleanupDone && (
                                            <p className="errormsg">{errors.wasImmediateCleanupDone}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Effected Passenger Flow</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="effectedPassengerFlow"
                                            value={values.effectedPassengerFlow}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.effectedPassengerFlow && touched.effectedPassengerFlow && (
                                            <p className="errormsg">{errors.effectedPassengerFlow}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Nature of Crowd</label>
                                        <SelectFild
                                            Firstop='Select'
                                            selectName="natureOfCrowd"
                                            options={[
                                                { name: 'Queue / Orderly Line', id: 'Queue / Orderly Line' },
                                                { name: 'Congested / High Density', id: 'Congested / High Density' },
                                                { name: 'Rushing / Hurry', id: 'Rushing / Hurry' },
                                                { name: 'Disorderly', id: 'Disorderly' },
                                                { name: 'Aggressive', id: 'Aggressive' },
                                                { name: 'Panic', id: 'Panic' },
                                                { name: 'Evacuation in Progress', id: 'Evacuation in Progress' },
                                                { name: 'Other', id: 'Other' },
                                            ]}
                                            value={values.natureOfCrowd}
                                            onChange={(selectedOption) => setFieldValue("natureOfCrowd", selectedOption?.value || "")}
                                            onBlur={handleBlur}
                                        />
                                        {errors.natureOfCrowd && touched.natureOfCrowd && (
                                            <p className="errormsg">{errors.natureOfCrowd}</p>
                                        )}
                                    </div>
                                </Col>
                                <Col md={4}>
                                    <div className="form-group">
                                        <label>Description</label>
                                        <textarea
                                            type="text"
                                            className="form-control"
                                            name="description"
                                            value={values.description}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                        {errors.description && touched.description && (
                                            <p className="errormsg">{errors.description}</p>
                                        )}
                                    </div>
                                </Col>
                            </Row>

                            <UploadWithSignature onFilesChange={setUploadedFiles} />

                            <div className='previewsimges'>
                                {preImg.map((fileUrl, index) => {
                                    if (fileUrl.toLowerCase().endsWith('.pdf')) {
                                        return (
                                            <div key={index} className='imageboxs'>
                                                <div className='imgs pdfs'>
                                                    <div>
                                                        <div className="pdf-icon">
                                                            <FaFilePdf size={48} color="#e74c3c" />
                                                        </div>
                                                        <a href={fileUrl} target="_blank" className='btn btn-orange' rel="noopener noreferrer">view Pdf</a>
                                                    </div>

                                                </div>
                                            </div>
                                        );
                                    }
                                    return (
                                        <div key={index} className='imageboxs'>
                                            <div className='imgs'>
                                                <img src={fileUrl} alt={`Image ${index + 1}`} />
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            <div className="button-boxs grid pt-2 pb-2">
                                <button type='submit' onClick={handleSubmit} className='btn btn-orange'>Submit</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            {isLoadings ? <Loader /> : null}
        </>
    );
}

export default BuildingInfrastructureRelated